const validate = {
  required(key) {
    return {
      required: true,
      message: `${key} should not be empty !`
    }
  },
  number(key) {
    return {
      type: 'number',
      message: `${key} should be a number !`
    }
  },
  email(key) {
    return {
      type: 'email',
      message: `${key} should be an email address !`
    }
  }
}

let keywords = Object.keys(validate).reduce((previousValue, currentValue) => Object.assign({}, previousValue, {[currentValue.toUpperCase()]: currentValue}), {})

export {validate, keywords}



// WEBPACK FOOTER //
// ./packages/helper/validate/index.js